import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function Chester() {
  return <CityManagementPage config={cityConfigs.chester} />;
}